import { apiGet, apiPost } from './api';
import { apiPut } from './adminService';  // re-uso do PUT helper

/* ============================================================
   USER endpoints (proprio ticket)
   ============================================================ */

export type TicketStatus = 'open' | 'answered' | 'closed';
export type TicketPriority = 'low' | 'normal' | 'high';

export interface TicketSummary {
  id: number;
  subject: string;
  status: TicketStatus;
  priority: TicketPriority;
  createdAt: string;
  updatedAt: string;
  lastReplyAt?: string | null;
  lastReplyByStaff: boolean;
  messageCount: number;
}

export interface TicketMessage {
  id: number;
  authorUserNum: number;
  authorId?: string | null;
  isStaff: boolean;
  body: string;
  createdAt: string;
}

export interface TicketDetail extends TicketSummary {
  messages: TicketMessage[];
}

export interface TicketCreateInput {
  subject: string;
  body: string;
}

export interface MessageCreateInput {
  body: string;
}

export const listMyTickets = (status?: TicketStatus) =>
  apiGet<TicketSummary[]>(`/tickets${status ? `?status=${status}` : ''}`);

export const createTicket = (input: TicketCreateInput) =>
  apiPost<TicketDetail>('/tickets', input);

export const getTicket = (id: number) =>
  apiGet<TicketDetail>(`/tickets/${id}`);

export const replyTicket = (id: number, input: MessageCreateInput) =>
  apiPost<TicketDetail>(`/tickets/${id}/messages`, input);


/* ============================================================
   ADMIN endpoints (GM)
   ============================================================ */

export interface AdminTicketRow extends TicketSummary {
  userNum: number;
  accountId?: string | null;
  assignedToUserNum?: number | null;
  assignedToId?: string | null;
}

export interface AdminTicketListResponse {
  total: number;
  items: AdminTicketRow[];
}

export interface AdminTicketFilter {
  skip?: number;
  limit?: number;
  status?: TicketStatus;
  user?: number;
  q?: string;
}

export const listAdminTickets = (filter?: AdminTicketFilter) => {
  const qs = new URLSearchParams();
  if (filter?.skip != null)  qs.append('skip', String(filter.skip));
  if (filter?.limit != null) qs.append('limit', String(filter.limit));
  if (filter?.status)        qs.append('status', filter.status);
  if (filter?.user != null)  qs.append('user', String(filter.user));
  if (filter?.q)             qs.append('q', filter.q);
  const tail = qs.toString() ? `?${qs.toString()}` : '';
  return apiGet<AdminTicketListResponse>(`/admin/tickets${tail}`);
};

export const getAdminTicket = (id: number) =>
  apiGet<TicketDetail>(`/admin/tickets/${id}`);

export const staffReply = (id: number, input: MessageCreateInput) =>
  apiPost<TicketDetail>(`/admin/tickets/${id}/messages`, input);

export interface TicketUpdateInput {
  status?: TicketStatus;
  priority?: TicketPriority;
  take?: boolean;
}

export const updateTicket = (id: number, input: TicketUpdateInput) =>
  apiPut<AdminTicketRow>(`/admin/tickets/${id}`, input);
